import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import config from "../../config";
import Cookies from "js-cookie";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import LanguageSelection from "../QuizInstruction/LanguageSelection";
import { languageSelectionModal, pathState } from "../../utils/recoil";
import { useRecoilState } from "recoil";
import Lottie from "react-lottie";
import animationData from "../../Assets/lottie/new-animation.json";
import Typewriter from "typewriter-effect";
import { useSearchParam } from "react-use";
import { useTranslation } from "react-i18next";

const QuizInstruction = () => {
  const { t, ready } = useTranslation("instruction");

  const navigate = useNavigate();
  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const isPaidCookie = Cookies.get("role", { domain: config.cookieDomain });
  const isTestTaken = Cookies.get("isTestAttended", {
    domain: config.cookieDomain,
  });
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useRecoilState(languageSelectionModal);
  const [path, setPath] = useRecoilState(pathState);
  const [instructionIndex, setInstructionIndex] = useState(null); 
  const [scale, setScale] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();


  useEffect(() => {
    if (isTestTaken && isTestTaken === "TRUE") {
      navigate("/path");
      setLoading(false)
    } else {
      setLoading(false);
    }
  }, [tokenCookie, isPaidCookie, isTestTaken, navigate])

  useEffect(() => {
    if (tokenCookie) {
      if (isTestTaken && isTestTaken === "TRUE") {
        navigate("/path");
        setLoading(false)
      } else {
        setLoading(false);
      }
    } else {
      navigate("/login");
    }
  }, [isTestTaken, navigate, tokenCookie])

  useEffect(() => {
    async function Scale() {
      const timer = setTimeout(() => {
        setScale(1.5);
      }, 100);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setInstructionIndex(0);
      return () => clearTimeout(timer);
    }

    Scale();
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return loading || !ready ? (
    <LoadingPage />
  ) : (
    <Layout>
      <LanguageSelection />
      <div className="bg-[#356dea10] rounded-2xl px-[4rem] mx-[4rem] mt-[2rem] py-[1rem] flex gap-5 justify-between text-xl sm-max:text-base sm-max:gap-2 md-max:mx-[2rem] md-max:px-[2rem] sm-max:mx-[1rem] sm-max:px-[1rem] sm-max:py-[1rem] relative overflow-hidden min-h-[90vh] md-max:h-full">
        <div className="flex flex-col gap-[1vh] w-full md-max:items-center">
          <p className="text-[4vh] leading-[40px] bg-gradient-to-r from-[#1C36BC] to-[#1C75BC] bg-clip-text text-transparent font-semibold sm-max:text-center w-[100vw] md-max:max-w-[90%]">
            {t("title")}
          </p>
          <div className="flex justify-between md-max:flex-col-reverse">
            <div className="max-w-[65%] md-max:max-w-full md-max:items-center">
              <div className=" flex flex-col md-max:my-4 gap-3 sm-max:gap-3">
                <p className="text-[2vh]">{t("description")}</p>

                <div className="flex flex-col gap-[1vh]">
                  {instructionIndex !== null && (
                    <div className="flex gap-[1vh]">
                      <div className="size-10 bg-white rounded-full flex justify-center items-center">
                        <Lottie
                          options={defaultOptions}
                          height={60}
                          width={60}
                        />
                      </div>

                      <div className="bg-white rounded-b-2xl rounded-tr-2xl px-6 py-3 text-[2vh]">
                        <Typewriter
                          options={{
                            strings: [t("instruction1")],
                            delay: 20,
                            cursor: " ",
                          }}
                          onInit={(typewriter) => {
                            typewriter
                              .typeString(t("instruction1"))
                              .start()
                              .pauseFor(1000)
                              .callFunction(() => {
                                console.log("String typed out!");
                                setInstructionIndex(1);
                              });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {instructionIndex >= 1 && (
                    <div className="flex gap-[1vh]">
                      <div className="size-10 bg-white rounded-full flex justify-center items-center">
                        <Lottie
                          options={defaultOptions}
                          height={60}
                          width={60}
                        />
                      </div>

                      <div className="bg-white rounded-b-2xl rounded-tr-2xl px-6 py-3 text-[2vh]">
                        <Typewriter
                          options={{
                            delay: 20,
                            cursor: " ",
                          }}
                          onInit={(typewriter) => {
                            console.log("hi");
                            console.log(typewriter);
                            typewriter
                              .typeString(t("instruction2"))
                              .start()
                              .callFunction(() => {
                                console.log("Second string typed out!");
                                setInstructionIndex(2);
                              });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {instructionIndex >= 2 && (
                    <div className="flex gap-[1vh]">
                      <div className="size-10 bg-white rounded-full flex justify-center items-center">
                        <Lottie
                          options={defaultOptions}
                          height={60}
                          width={60}
                        />
                      </div>

                      <div className="bg-white rounded-b-2xl rounded-tr-2xl px-6 py-3 text-[2vh]">
                        <Typewriter
                          options={{
                            delay: 20,
                            cursor: " ",
                          }}
                          onInit={(typewriter) => {
                            typewriter
                              .typeString(t("instruction3"))
                              .start()
                              .callFunction(() => {
                                setInstructionIndex(3);
                              });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {instructionIndex >= 3 && (
                    <div className="flex gap-[1vh]">
                      <div className="size-10 bg-white rounded-full flex justify-center items-center">
                        <Lottie
                          options={defaultOptions}
                          height={60}
                          width={60}
                        />
                      </div>

                      <div className="bg-white rounded-b-2xl rounded-tr-2xl px-6 py-3 text-[2vh]">
                        <Typewriter
                          options={{
                            delay: 20,
                            cursor: " ",
                          }}
                          onInit={(typewriter) => {
                            typewriter
                              .typeString(t("instruction4"))
                              .start()
                              .callFunction(() => {
                                setInstructionIndex(4);
                              });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {instructionIndex >= 4 && (
                    <div className="flex gap-[1vh]">
                      <div className="size-10 bg-white rounded-full flex justify-center items-center">
                        <Lottie
                          options={defaultOptions}
                          height={60}
                          width={60}
                        />
                      </div>

                      <div className="bg-white rounded-b-2xl rounded-tr-2xl px-6 py-3 text-[2vh]">
                        <Typewriter
                          options={{
                            delay: 20,
                            cursor: " ",
                          }}
                          onCharacterTyped={(char) => {
                            console.log("hi");
                          }}
                          onInit={(typewriter) => {
                            typewriter
                              .typeString(t("instruction5"))
                              .start()
                              .callFunction(() => {
                                setInstructionIndex(5);
                              });
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {instructionIndex >= 5 && (
                    <div className="flex gap-[1vh]">
                      <div className="size-10 bg-white rounded-full flex justify-center items-center">
                        <Lottie
                          options={defaultOptions}
                          height={60}
                          width={60}
                        />
                      </div>

                      <div className="bg-white rounded-b-2xl rounded-tr-2xl px-6 py-3 text-[2vh]">
                        <Typewriter
                          options={{
                            delay: 20,
                            cursor: " ",
                          }}
                          onInit={(typewriter) => {
                            typewriter
                              .typeString(t("instruction6"))
                              .start()
                              .callFunction(() => {
                                setInstructionIndex(6);
                              });
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {instructionIndex >= 6 && (
                <div className="text-[2vh] mt-[2vh]">
                  <Typewriter
                    options={{
                      delay: 20,
                      cursor: " ",
                    }}
                    onInit={(typewriter) => {
                      typewriter.typeString(`${t("instruction7")}`).start();
                    }}
                  />

                  <Typewriter
                    options={{
                      delay: 20,
                      cursor: " ",
                    }}
                    onInit={(typewriter) => {
                      typewriter
                        .typeString(t("instruction8"))
                        .start()
                        .callFunction(() => {
                          document.querySelector(
                            ".begin-button"
                          ).style.display = "block";
                          document.querySelector(
                            ".begin-button-2"
                          ).style.display = "block";
                        });
                    }}
                  />
                  <div className="flex justify-start gap-4 md-max:flex-col md-max:justify-center mt-[1.5vh]">
                    <button
                      onClick={() => { setVisible(true); setPath("student") }}
                      className="bg-[#1C75BC] text-white rounded-lg py-[1.5vh] px-[2rem] text-[2vh] font-semibold text-xl md-max:text-sm begin-button"
                      style={{ display: "none" }}
                    >
                      {t("button1")}
                    </button>
                    <button
                      onClick={() => { setVisible(true); setPath("professional") }}
                      className="bg-[#1C75BC] text-white rounded-lg py-[1.5vh] px-[2rem] text-[2vh] font-semibold text-xl md-max:text-sm begin-button-2"
                      style={{ display: "none" }}
                    >
                      {t("button2")}
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div
              className="overflow-visible transition-transform duration-1000 ease-in-out h-[80vh] md-max:hidden"
              style={{
                transform: `scale(${window.innerWidth <= 1280
                  ? Math.min(scale, 1)
                  : // 1024 <= window.innerWidth <= 1280 ? Math.min(scale, 1.1) :
                  scale
                  })`,
              }}
            >
              <Lottie options={defaultOptions} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default QuizInstruction;
